import { useContext } from "react";
import Context from "../../../../context";
import {
  CustomBadges,
  CustomIcon,
  TableNullData,
  UserInformation,
} from "../../../../components";
import { ICreateAndUpdateMunicipality } from "../../../../types/municipality.interface";

const Body = (data: any) => {
  const { resultMunicipality, setSelectedMunicipality, setShowModal } =
    useContext(Context.MunicipalityScreen);

  const municipalities = resultMunicipality?.data?.result?.docs;

  const onDetail = (municipality: ICreateAndUpdateMunicipality) => {
    setSelectedMunicipality!(municipality);
    setShowModal!("DETAIL");
  };
  const onUpdate = (municipality: ICreateAndUpdateMunicipality) => {
    setSelectedMunicipality!(municipality);
    setShowModal!("UPDATE");
  };
  const onDelete = (municipality: ICreateAndUpdateMunicipality) => {
    setSelectedMunicipality!(municipality);
    setShowModal!("DELETE");
  };

  if (municipalities?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="driver-table-body-container">
      {municipalities?.map((municipality: any, index: number) => {
        return (
          <tr key={`driver-${index}`}>
            <td className="pointer">
              <UserInformation
                name={municipality?.name}
                phoneNumber={municipality?.address}
                hideAvatar
              />
            </td>
            <td>
              <CustomBadges title={municipality?.province} />
            </td>
            <td className="pointer">
              <CustomBadges title={municipality?.city} />
            </td>
            {/* Status */}

            {/* actions */}
            <td>
              <div className="table-actions-buttons">
                {/* Edit Icon */}
                <CustomIcon
                  icon="fas fa-pen"
                  hoverTitle="ویرایش"
                  onClick={() => onUpdate(municipality)}
                />
                <CustomIcon
                  icon="fas fa-trash"
                  hoverTitle="حذف"
                  onClick={() => onDelete(municipality)}
                />
              </div>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
